var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM11.7035 15.6976C12.3273 15.6976 12.8201 16.202 12.8201 16.8447C12.8201 17.4875 12.3273 18 11.7035 18C11.0798 18 10.5792 17.4875 10.5792 16.8447C10.5792 16.202 11.0798 15.6976 11.7035 15.6976ZM11.9807 6C14.0677 6 15.5 7.25288 15.5 9.09153C15.5 10.3363 14.9147 11.1905 13.8674 11.8495C12.8586 12.4678 12.6122 12.8583 12.5506 13.5986C12.4736 14.1356 12.2118 14.4692 11.6881 14.4692C11.1447 14.4692 10.827 14.0903 10.7844 13.5607L10.7794 13.4359V13.2814C10.7794 12.3398 11.1953 11.6959 12.0334 11.1247L12.2195 11.0034C13.1744 10.3932 13.4978 9.94576 13.4978 9.16475C13.4978 8.27797 12.8432 7.65966 11.896 7.65966C11.0413 7.65966 10.4714 8.10712 10.225 8.92881C10.0556 9.43322 9.77063 9.63661 9.34708 9.63661C8.81573 9.63661 8.5 9.29492 8.5 8.74983C8.5 8.4 8.56931 8.09898 8.71562 7.78983C9.19307 6.68339 10.3944 6 11.9807 6Z",
    fill: "#0E0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.5f49e3221a9138760843aff001d1a1e4.svg";
export { ForwardRef as ReactComponent };